/* eslint-disable @typescript-eslint/naming-convention */
import { IBopisInfoResponse, INotification } from '../../IApiResponses';
import { IAPIBopisData, IBopisData, IFromBopisInfoResponse } from '../../IDataMappings';
import notificationsMapper from './notificationsMapper';

const bopisInfoMapper = {
  request(info: IBopisData): IAPIBopisData {
    const {
      doorId,
      purchaserPhone,
      purchaserEmail,
      purchaserLastName,
      purchaserFirstName,
      proxyMode,
      proxyPhone,
      proxyEmail,
      proxyLastName,
      proxyFirstName,
    } = info;

    let proxy = {};

    if (proxyMode) {
      proxy = {
        proxy_bopis_email: proxyEmail,
        proxy_bopis_first_name: proxyFirstName,
        proxy_bopis_last_name: proxyLastName,
        proxy_bopis_phone_number: proxyPhone,
      };
    }

    return {
      door_id: doorId,
      door_mode: 'set',
      no_address_delete: 0,
      no_cart_delete: 0,
      proxy_pickup_mode: proxyMode ? 'set' : 'unset',
      purchaser_bopis_email: purchaserEmail,
      purchaser_bopis_first_name: purchaserFirstName,
      purchaser_bopis_last_name: purchaserLastName,
      purchaser_bopis_phone_number: purchaserPhone,
      purchaser_pickup_mode: 'set',
      ...proxy,
    };
  },
  response(bopisInfo: IBopisInfoResponse): IFromBopisInfoResponse {
    const bopisObj = bopisInfo.bopis || bopisInfo;
    const {
      bopis_is_bopis_or_courier,
      bopis_is_bopis_order,
      bopis_is_courier,
      bopis_purchaser_pickup_info: {
        bopis_email_address,
        bopis_first_name,
        bopis_last_name,
        bopis_phone_number,
      },
      bopis_proxy_pickup_info: {
        proxy_email_address,
        proxy_first_name,
        proxy_last_name,
        proxy_phone,
      },
      bopis_store_number,
    } = bopisObj;
    
    const notificationsItems: INotification[] = notificationsMapper.response(bopisInfo.notifications || []);

    return {
      doorId: bopis_store_number.toString(),
      isBopisOrCourier: !!bopis_is_bopis_or_courier,
      isBopisOrder: !!bopis_is_bopis_order,
      isCourier: !!bopis_is_courier,
      notifications: notificationsItems,
      proxyPickupInfo: {
        email: proxy_email_address,
        firstName: proxy_first_name,
        lastName: proxy_last_name,
        phone: proxy_phone,
      },
      proxyPickupMode: !!proxy_email_address,
      purchaserPickupInfo: {
        email: bopis_email_address,
        firstName: bopis_first_name,
        lastName: bopis_last_name,
        phone: bopis_phone_number,
      },
    };
  },
};

export default bopisInfoMapper;